import { KYMW1002Model } from '../kymw1002.model';
import { Injectable, inject } from "@angular/core";
import {  } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 処理ログダウンロードパスを取得するサービス
 *
 * @export GetResultLogPathService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetResultLogPathService
  extends PlessJsonResponderSub<string> {

  private model: KYMW1002Model;
  private successFunc: () => void;
  private codeValue: string = "";

  execute(
    model: KYMW1002Model,
    codeValue: string,
    successFunc?: () => void
  ): void {
    this.model = model;
    this.codeValue = codeValue;
    this.successFunc = successFunc;
    this.send('getResultLogPath', this.getBody());
  }

  success(data: string): void {
    this.model.resultLogPath = data;
    if (this.successFunc) {
      this.successFunc();
    }
  }

  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CodeValue: this.codeValue
      }
    });
  }
}

